import { apiClient } from '@api/client';
import type { LoginRequest, LoginResponse, RegisterRequest, RegisterResponse, User } from '../types';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const { data } = await apiClient.post<LoginResponse>('/auth/login', credentials);
    return data;
  },

  register: async (userData: RegisterRequest): Promise<RegisterResponse> => {
    const { data } = await apiClient.post<RegisterResponse>('/auth/register', userData);
    return data;
  },

  // Выход отзывает ОБЕ стороны пары. В заголовке уходит только access-токен,
  // поэтому refresh передаётся телом — той же формой, что и в /auth/refresh.
  // Поле необязательное на сервере: если токена нет, выход всё равно проходит.
  logout: async (): Promise<void> => {
    let refreshToken: string | null = null;
    try {
      refreshToken = localStorage.getItem('refresh_token');
    } catch {
      refreshToken = null;
    }
    await apiClient.post('/auth/logout', refreshToken ? { refresh_token: refreshToken } : {});
  },

  getCurrentUser: async (): Promise<User> => {
    const { data } = await apiClient.get<User>('/auth/me');
    return data;
  },

  refreshToken: async (refreshToken: string): Promise<LoginResponse> => {
    const { data} = await apiClient.post<LoginResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return data;
  },

  // Смена своего пароля. user_id не передаём — сервер трактует пусто как self и
  // проверяет текущий пароль. Пароли идут телом через воронку apiClient; в логи
  // и в URL не попадают.
  changePassword: async (oldPassword: string, newPassword: string): Promise<void> => {
    await apiClient.post('/auth/change-password', {
      old_password: oldPassword,
      new_password: newPassword,
    });
  },
};

